export default __webpack_public_path__ + "static/media/outcess16.caa57f20.jpeg";